import React from 'react';
import Loadable from 'react-loadable';
import Loader from '../../components/BlankLoader/BlankLoader';

const NotFoundLoadable = Loadable({
    loader: () => import('./NotFound' /* webpackChunkName: 'not-found' */).then(module => module.default),
    loading: () => <Loader />
});

export default NotFoundLoadable;
